export default __webpack_public_path__ + "static/media/existing-banner.f2e82db1.jpg";